import { useAuth } from "@/context/AuthContext";
import Stock from "@/pages/Stock";

export default function WorkerHome() {
  const { user } = useAuth();
  return (
    <div>
      <div className="mb-6 rounded-lg overflow-hidden relative bg-[#0b0f19] text-white" data-testid="worker-home">
        <div
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage: "url(https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400)",
            backgroundSize: "cover", backgroundPosition: "center",
          }}
        />
        <div className="relative p-6 sm:p-8">
          <div className="text-xs uppercase tracking-[0.3em] text-primary font-bold">GÜMÜŞALAN ELEKTRİK · DEPO</div>
          <h2 className="font-head text-2xl sm:text-3xl font-black mt-1">Merhaba {user?.name}</h2>
          <p className="text-white/60 text-sm mt-1">Ürünleri görüntüleyin, stok sayımı girin ve eksik ürünleri iletin.</p>
        </div>
      </div>
      <Stock />
    </div>
  );
}
